export default __webpack_public_path__ + "static/media/TV_Futura_icon.3211d72f.png";